import React, { useCallback } from 'react';
import AsyncSelect from 'react-select/async';
import api from '../../services/api';

const toOption = item => ({
  value: item.id,
  label: item.display_name,
});

const AsyncBasketSelect = ({
  repairRequestId,
  equipmentId,
  targetStatus,
  value,
  onChange,
  placeholder = 'Введите номер корзины, например 916',
  isDisabled = false,
  className,
  classNamePrefix = 'basket-select',
  styles,
  menuPortalTarget,
}) => {
  const loadOptions = useCallback(async (inputValue = '') => {
    if (!repairRequestId || !targetStatus) return [];
    const { data } = await api.get('/repairs/baskets/available/', {
      params: {
        repair_request_id: repairRequestId,
        equipment_id: equipmentId || undefined,
        target_status: targetStatus,
        search: inputValue.trim(),
        limit: 80,
      },
    });
    return (Array.isArray(data) ? data : []).map(toOption);
  }, [repairRequestId, equipmentId, targetStatus]);

  return (
    <AsyncSelect
      key={`${repairRequestId || 'request'}:${equipmentId || 'equipment'}:${targetStatus || 'stage'}`}
      cacheOptions={false}
      defaultOptions
      loadOptions={loadOptions}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      isDisabled={isDisabled || !repairRequestId || !targetStatus}
      isClearable
      className={className}
      classNamePrefix={classNamePrefix}
      styles={styles}
      menuPortalTarget={menuPortalTarget}
      loadingMessage={() => 'Поиск корзин…'}
      noOptionsMessage={({ inputValue }) => (
        inputValue
          ? 'Корзина не найдена либо недоступна для выбранного этапа'
          : 'Нет пустых или совместимых корзин для выбранного этапа'
      )}
    />
  );
};

export default AsyncBasketSelect;
